import { Component, ViewEncapsulation, ChangeDetectorRef, ViewChild, OnDestroy, Input } from '@angular/core';
import { Subscription, throwError } from 'rxjs';
import { GlobalsService } from '../shared/services/globals.service';
import { BaseDQOIComponent } from '../shared/base-components/base-dqoi.component';
import { DQOIService } from '../shared/services/DQOI.service';
import { DQOIReferenceDataQuery } from '../dqoi/state/dqoi-reference-data.query';
import { UntypedFormGroup, UntypedFormControl, Validators, FormControl } from '@angular/forms';
import { CommonFunctions } from '../shared/static/common-functions';
import { SearchTarget } from '../shared/enums/SearchTarget';
import { GItem } from '../shared/models/GItem';
import { Address } from '../shared/models/Address';
import { CustomerService } from '../shared/services/customer.service';
import { SelectEvent } from '@progress/kendo-angular-layout';
import { QuoteBus } from '../shared/models/QuoteBus';
import { QuoteService } from '../shared/services/quote.service';
import { AdditionalQuoteData } from '../shared/models/AdditionalQuoteData';
import { QuotePage } from '../shared/models/QuotePage';
import { DispatchesService } from '../shared/services/dispatches.service';
import { DateFunctions } from '../shared/static/date-functions';
import { v_LocationDetailBus } from '../shared/models/v_LocationDetailBus';
import { CommonValues } from '../shared/static/CommonValues';
import { QuoteInfo } from '../shared/models/QuoteInfo';
import { GeographyInfoBus } from '../shared/models/GeographyInfoBus';
import * as _ from 'lodash';
import { MessageType } from '../shared/enums/MessageType';
import { DQOIItem } from '../shared/models/DQOIItem';
import { Message } from '../shared/models/message';
import { QuoteTemplate } from '../shared/models/QuoteTemplate';
import { QuoteTemplateSaveComponent } from './quote-template-save/quote-template-save.component';
import { QuoteMessageInfo } from '../shared/models/QuoteMessageInfo';
import { SaveMode } from '../shared/enums/SaveMode';
import { AttachmentBus } from '../shared/models/AttachmentBus';
import { BaseMessageInfo } from '../shared/models/BaseMessageInfo';
import { FileInfo } from '@progress/kendo-angular-upload';
//import { attachEmbeddedView } from '@angular/core/src/view';
import { CDocument } from '../shared/models/CDocument';
import { QuoteLineItemsComponent } from './quote-lineitems/quote-lineitems.component';
import { QuoteNotesComponent } from './quote-notes/quote-notes.component';
import { QuoteAttachmentsComponent } from './attachments/quote-attachments.component';
import { QuoteEquipmentComponent } from './equipment/quote-equipment.component';
import { QuoteSaveParam } from '../shared/models/QuoteSaveParam';
import { ConstructionService } from '../shared/services/construction.service';
import { CnstMessageInfo } from '../shared/models/CnstMessageInfo';
import { TaxCodeBus } from '../shared/models/TaxCodeBus';
import { CPSearchComponent } from '../shared/search/cp-search/cp-search.component';
import { v_QuoteDetailBus } from '../shared/models/v_QuoteDetailBus';
import { CommonActions } from '../shared/enums/CommonActions';
import { retry } from 'rxjs/operators';
import { TaxCodeComponent } from '../shared/components/tax-code/tax-code.component';
import { v_QuoteNoteBus } from '../shared/models/v_QuoteNoteBus';
import { v_QuoteInvoiceBus } from '../shared/models/v_QuoteInvoiceBus';
import { CommonParam } from '../shared/models/CommonParam';
import { InvoicePickerComponent } from '../dispatches/invoice-picker/invoice-picker.component';
import { CRUDActions } from '../shared/enums/CRUDActions';
import { CPDialogResult } from '../shared/enums/CPDialogResult';
import { ConfirmOutput } from '../shared/models/ConfirmOutput';
import { Router } from '@angular/router';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { LineItemPricingRangeBus } from '../shared/models/LineItemPricingRangeBus';
import { AuthenticationService } from '../shared/services/authentication.service';
import { PrintService } from '../shared/services/print.service';
import { UseCPLoader, ICPLoader } from '../shared/decorators/cploader/cploader-decorator';
import { UseFeatureFlagSet, IFeatureFlagSet } from '../shared/decorators/featureflags/featureflagset-decorator';
import { PdfResponse } from '../shared/models/PdfResponse';
import { DQOIQuoteDisplaySettings } from '../shared/models/DQOIDisplaySettings';

export class TestPut {
    id: number;
    code: string;
}

@UseCPLoader()
@UseFeatureFlagSet()
@Component({
    selector: 'quotes',
    templateUrl: './quotes.component.html',
    styleUrls: ['./quotes.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class QuotesComponent extends BaseDQOIComponent<QuoteBus, QuoteService, AdditionalQuoteData, QuotePage> implements OnDestroy {
    compFeatureFlagSet: IFeatureFlagSet = this as any;
    compLoader: ICPLoader = this as any;
    @ViewChild("quoteTemplateSave") quoteTemplateSaveComponent: QuoteTemplateSaveComponent;
    public svc_auth: AuthenticationService;

    locationDetailClass: string = "v_LocationDetailBus";
    billToAddress: Address = new Address();
    locationAddress: Address = new Address();
    scopeText: string;
    termText: string;
    count: number;
    popUp: boolean = false;

    custLocPricingRanges: LineItemPricingRangeBus[] = [];
    svc_cnst: ConstructionService;
    subs_notes: Subscription;
    appCode: string = "Quote";
    isAvalaraTaxCodeInfo: boolean = false;
    canEditQuote: boolean;
    isWarranty: boolean;
    isNewQuote: boolean = false;
    isRelJobTypeCO: boolean = false;
    //gets updated by quote-lineitems when it detects lineitems
    hasLineItems: boolean = false;
    public isEquipmentWithInstallReadOnly: boolean = true; //default setting when Equipment Sales is NOT selected for Class ddl

    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, svc_dqoi: DQOIService, qry_rd: DQOIReferenceDataQuery, svc_data: QuoteService,
        private svc_customer: CustomerService, svc_disp: DispatchesService, private printService: PrintService,
        svc_cnst: ConstructionService, svc_auth: AuthenticationService, private router: Router) {
        super(globals, featureFlagService, svc_dqoi, qry_rd);
        this.svc_data = svc_data;
        this.svc_auth = svc_auth;
        this.svc_cnst = svc_cnst;
        this.addtlDataClass = "AdditionalQuoteData";
        this.searchTarget = SearchTarget.quote;
        this.pageData = new QuotePage(svc_data, svc_disp);
        this.saveMode = SaveMode.all;
        this.setupCheckForm();
    }

    reduceToMinData() { }
    @ViewChild("invoicePicker") invoicePicker: InvoicePickerComponent;
    @ViewChild("LineItems") lineItemsComp: QuoteLineItemsComponent;
    @ViewChild("Notes") notesComp: QuoteNotesComponent;
    @ViewChild("Attachments") attachmentsComp: QuoteAttachmentsComponent;
    @ViewChild("Equipment") equipComp: QuoteEquipmentComponent;
    @ViewChild('cpSearchDispatchs') CpSearchDispatchs: CPSearchComponent;
    @ViewChild('cpSearchQuoteTemplates') CpSearchQuoteTemplates: CPSearchComponent;
    @ViewChild('cpSearchQuotes') CpSearchQuotes: CPSearchComponent;
    @ViewChild("TaxCode") taxCodeComponent: TaxCodeComponent;

    @Input() dqoiQuoteDisplaySettings: DQOIQuoteDisplaySettings = new DQOIQuoteDisplaySettings();

    public editForm: UntypedFormGroup = new UntypedFormGroup({
        'quoteId': new UntypedFormControl(),
        'companyId': new UntypedFormControl(),
        'customerId': new UntypedFormControl('', Validators.required),
        'locationId': new UntypedFormControl('', Validators.required),
        'quoteStatusId': new UntypedFormControl('', Validators.required),
        'salespersonId': new UntypedFormControl(),
        'isTemplate': new UntypedFormControl(),
        'billingGeographyId': new UntypedFormControl(),
        'shippingGeographyId': new UntypedFormControl(),
        'dispatchId': new UntypedFormControl(),
        'invoiceId': new UntypedFormControl(),
        'quoteDate': new UntypedFormControl(null, Validators.required),
        'followUpDate': new UntypedFormControl(),
        'quoteNumber': new UntypedFormControl(),
        'ponumber': new UntypedFormControl(),
        'quoteDesc': new UntypedFormControl(),
        'insertDt': new UntypedFormControl(),
        'insertUserId': new UntypedFormControl(),
        'updateDt': new UntypedFormControl(),
        'updateUserId': new UntypedFormControl(),
        'taxCodeId': new UntypedFormControl(CommonValues.Avalara_TaxCode, Validators.required),
        'taxAmount': new UntypedFormControl(),
        'termId': new UntypedFormControl(''),
        'wonumber': new UntypedFormControl(),
        'accountClassId': new UntypedFormControl('', Validators.required),
        'scopeText': new UntypedFormControl(''),
        'termText': new UntypedFormControl(''),
        'notIncludedText': new UntypedFormControl(''),
        'warrantyText': new UntypedFormControl(''),
        'extendedWarrantyCost': new UntypedFormControl(),
        'extendedWarrantyYears': new UntypedFormControl(),
        'overrideContactName': new UntypedFormControl(),
        'printWithTerms': new UntypedFormControl(true),
        'cost': new UntypedFormControl(null as number),
        'costMaterial': new UntypedFormControl(null as number),
        'costLabor': new UntypedFormControl(null as number),
        'saleMaterial': new UntypedFormControl(null as number),
        'saleLabor': new UntypedFormControl(null as number),
        'amount': new UntypedFormControl(null as number),
        'total': new UntypedFormControl(null as number),
        'costOther': new UntypedFormControl(null as number),
        'saleOther': new UntypedFormControl(null as number),
        'changeReqInfo': new UntypedFormControl(),
        'isPassThrough': new UntypedFormControl(null as number),
        'isNewConstruction': new UntypedFormControl(null as number),
        'isEquipmentWithInstall': new FormControl(null as number),
        'generalContractors': new UntypedFormControl([]),
        'dispatchNumber': new UntypedFormControl(),
        'dispatchDate': new UntypedFormControl(),
        'profit': new UntypedFormControl(),
        'profitPct': new UntypedFormControl(),
        'callbackNumber': new UntypedFormControl(),
        'invoiceNumber': new UntypedFormControl(),
        'acctMgr': new UntypedFormControl(),
        'createdBy': new UntypedFormControl(),
        'templateId': new UntypedFormControl(),
        'useTax': new UntypedFormControl(),
        'taxTypeCode': new UntypedFormControl(),
        'isAvalara': new UntypedFormControl(),
        'bidSheetNumber': new UntypedFormControl(),
        'mainBidNo': new UntypedFormControl(),
        'divisionId': new UntypedFormControl(),
    });

    setFormConstructionValidation() {
        /*this.editForm.get('salespersonId').valueChanges.subscribe((value => {

        }))*/
        const salespersonId = this.editForm.get('salespersonId');
        const divisionId = this.editForm.get('divisionId');
        const validators = [Validators.required];
        if (this.isConstruction) {
            salespersonId.setValidators(validators);
            if (this.compFeatureFlagSet.featureFlagSet['construction-bids-screen-add-new-field-for-division']) {
                divisionId.setValidators(validators);
            }
        } else {
            salespersonId.clearValidators();
            if (this.compFeatureFlagSet.featureFlagSet['construction-bids-screen-add-new-field-for-division']) {
                divisionId.clearValidators();
            }
        }
    }

    setForm() {
        this.isRelJobTypeCO = false;
        this.getBidData(this.data.quoteId);
        this.editForm.patchValue({
            quoteId: this.data.quoteId,
            companyId: this.data.companyId,
            customerId: this.data.customerId,
            locationId: this.data.locationId,
            quoteStatusId: this.data.quoteStatusId,
            salespersonId: this.data.salespersonId,
            isTemplate: this.data.isTemplate,
            billingGeographyId: this.data.billingGeographyId,
            shippingGeographyId: this.data.shippingGeographyId,
            dispatchId: this.data.dispatchId,
            invoiceId: this.data.invoiceId,
            quoteDate: this.data.quoteDate,
            followUpDate: this.data.followUpDate,
            quoteNumber: this.data.quoteNumber,
            ponumber: this.data.ponumber,
            quoteDesc: this.data.quoteDesc,
            insertDt: this.data.insertDt,
            insertUserId: this.data.insertUserId,
            updateDt: this.data.updateDt,
            updateUserId: this.data.updateUserId,
            taxCodeId: this.data.taxCodeId ? this.data.taxCodeId : CommonValues.Avalara_TaxCode,
            taxAmount: this.data.taxAmount,
            termId: this.data.termId,
            wonumber: this.data.wonumber,
            accountClassId: this.data.accountClassId,
            scopeText: this.data.scopeText,
            termText: this.data.termText,
            notIncludedText: this.data.notIncludedText,
            warrantyText: this.data.warrantyText,
            extendedWarrantyCost: this.data.extendedWarrantyCost,
            extendedWarrantyYears: this.data.extendedWarrantyYears,
            overrideContactName: this.data.overrideContactName,
            printWithTerms: this.data.printWithTerms,
            cost: this.data.cost,
            costMaterial: this.data.costMaterial,
            costLabor: this.data.costLabor,
            saleMaterial: this.data.saleMaterial,
            saleLabor: this.data.saleLabor,
            amount: this.data.amount,
            total: this.data.total,
            costOther: this.data.costOther,
            saleOther: this.data.saleOther,
            changeReqInfo: this.data.changeReqInfo,
            isPassThrough: this.data.isPassThrough,
            isNewConstruction: this.data.isNewConstruction,
            isEquipmentWithInstall: this.data.isEquipmentWithInstall,
            useTax: this.data.useTax,
            taxTypeCode: this.data.taxTypeCode,
            isAvalara: this.data.isAvalara,
            profit: CommonFunctions.formatMoney(CommonFunctions.calculateProfit(this.data.cost, this.data.amount)),
            profitPct: CommonFunctions.formatPct(CommonFunctions.calculateProfitPct(this.data.cost, this.data.amount)),
            divisionId: this.data.divisionId
        });
        this.scopeText = this.data.scopeText;
        this.termText = this.data.termText;
        this.setFormFlags();
        this.setFormConstructionValidation();
        this.checkBidNCStatus();

        if (this.isConstruction) {
            if (this.compFeatureFlagSet.featureFlagSet['construction-quote-controls']) {
                if (this.data.quoteId) {
                    this.svc_data.getAdditionalData(this.data.quoteId).subscribe(data => {
                        if (this._masterId)
                            { this.getListFromMaster(); }
                        this.addtlData = new AdditionalQuoteData(data);
                        if (this.addtlData.detail.relatedJobTypeId != null) {
                            if (this.addtlData.detail.relatedJobTypeId == CommonValues.RelatedJobType_PostWarranty ||
                                this.addtlData.detail.relatedJobTypeId == CommonValues.RelatedJobType_ManufacturerWarrantyCarpentry ||
                                this.addtlData.detail.relatedJobTypeId == CommonValues.RelatedJobType_ManufacturerWarrantyElectrical ||
                                this.addtlData.detail.relatedJobTypeId == CommonValues.RelatedJobType_ManufacturerWarrantyRefrigeration) {
                                this.canEditQuote = true;
                            } else {
                                if (this.data.quoteId && this.data.dispatchId) {
                                    this.getUserPermissions();
                                } else {
                                    this.canEditQuote = true;
                                }
                            }
                        } else {
                            this.canEditQuote = true;
                        }
                    });
                } else {
                    this.canEditQuote = true;
                }
            } else {
                this.canEditQuote = true;
            }

            if (this.compFeatureFlagSet.featureFlagSet['quotes-new-status-for-pending-atp']) {
                if (this.data.relatedJobTypeId) {
                    if (this.data.relatedJobTypeId == CommonValues.RelatedJobType_ChangeOrder) {
                        this.isRelJobTypeCO = true;
                        this.editForm.patchValue({
                            quoteStatusId: CommonValues.Quote_PendingATP
                        });
                    } else {
                        this.isRelJobTypeCO = false;
                        this.editForm.patchValue({
                            quoteStatusId: CommonValues.Quote_Pending
                        });
                    }
                }
            }

        } else {
            this.canEditQuote = true;
        }

        this.taxCodesCanSelectAndCurrent(this.data.taxCodeId);

        if (this.isConstruction) {
            if (this.data.accountClassId === CommonValues.Quote_Class_Equipment_Sales) {
                this.isEquipmentWithInstallReadOnly = false;
            }
        }
    }

    taxCodeData = [];

    taxCodesCanSelectAndCurrent(taxCodeId) {
        this.taxCodeData = [];
        if (this.referenceData.taxCodes) {
            this.referenceData?.taxCodes.forEach(e => {
                if (e.canSelect) {
                    this.taxCodeData.push(e);
                }
            });
            const item = this.referenceData?.taxCodes.find(e => e.value === taxCodeId);
            if (item) {
                if (!this.taxCodeData.find(e => e == item)) {
                    this.taxCodeData.push(item);
                }
            }
        }
        return this.taxCodeData;
    }

    customReferenceData() {
        this.taxCodesCanSelectAndCurrent(this.data?.taxCodeId);
    }

    public getUserPermissions() {
        let x;
        let uid = this.globals.userId;
        const today = new Date();
        let lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1);
        this.svc_auth.userFeatures(uid).subscribe(data => {
            if (data) {
                x = data.filter(x => x.value === CommonValues.Permission_EditConstructionQuotes);
                if (x.length == 0) {
                    if ((this.data.quoteDate.getMonth()) === today.getMonth()) {
                        if (this.data.quoteDate < lastDayOfMonth) {
                            this.canEditQuote = true;
                        }
                    } else {
                        this.canEditQuote = false;
                    }
                } else {
                    this.canEditQuote = true;
                }
            }
        });
    }

    setFormAddtl() {
        this.editForm.patchValue({
            billingStreet: this.billToAddress.addressLine1,
            billingCityStateZip: this.billToAddress.cityStateZip, // CommonFunctions.cityStateZip(this.addtlData.billingAddress.city, this.addtlData.billingAddress.stateProvince, this.addtlData.billingAddress.postalCode),
            dispatchNumber: this.addtlData.detail.dispatchNumber,
            dispatchDate: this.addtlData.detail.dispatchDate,
            callbackNumber: this.addtlData.detail.callbackNumber,
            invoiceNumber: this.addtlData.detail.invoiceNumber,
            generalContractors: this.getGeneralContractors(),
            acctMgr: this.addtlData.acctMgr,
            createdBy: this.addtlData.createdBy

            //invoiceNumber: this.addtlData.detail.i
        });
        this.setFormFlags();
    }
    setDefaults() {
        this.editForm.patchValue({
            scopeText: "<p>The scope of the job is outlined below:</p>",
            termText: "<p style=\"font-family:Verdana;font-size:10pt;margin:6.7px 0;\">· Equipment: 50% down at time of equipment order, Balance at time of delivery</p><p style=\"font-family:Verdana;font-size:10pt;margin:6.7px 0;\">· Installation: 25% down at project start, draws Net 30 days on approved credit.</p>",
            notIncludedText: "<p style=\"font-family:Verdana;font-size:10pt;margin:6.7px 0;\">· State and local sales or use tax</p><p>· Supplemental refrigerated storage (if required)</p><p>·Additional Transportation</p>",
            warrantyText: "<p style=\"font-family:Verdana;font-size:10pt;margin:6.7px 0;\">· Our Workmanship - 3 months</p>"

            //invoiceNumber: this.addtlData.detail.i
        });
        this.setDirty();
    }
    get canAddNewQuote(): boolean {
        return (this.isConstruction || !this.hasId);
    }
    setFormLocation(data: v_LocationDetailBus) {
        this.editForm.patchValue({
            //billingStreet: this.billToAddress.addressLine1,
            //billingCityStateZip: this.billToAddress.cityStateZip,
            billingGeographyId: data.billingGeographyId,
            shippingGeographyId: data.geographyId,
            termId: data.termId,
            salespersonId: this.isConstruction ? null : data.salespersonId,
            taxCodeId: data.taxCodeId,
            acctMgr: data.acctManName
            //invoiceNumber: this.addtlData.detail.i
        });
    }
    setFormTaxCode(data: TaxCodeBus) {
        this.editForm.patchValue({
            taxCode: data
        });
    }
    protected resetData(dqoiItem: DQOIItem) {
        super.resetData(dqoiItem);
        if (dqoiItem.hasDispatchId) {
            this._masterId = dqoiItem.dispatchId;
            this.getListFromMaster();
        }
        if (dqoiItem.hasQuoteId) {
            this.getDataFromId(dqoiItem.quoteId);
            this.count = dqoiItem.quoteCount;
        }
    }
    setDQOIState() {
        if (CommonFunctions.hasValue(this.dqoiIndex) && this.dqoiIndex > 0) {
            let item: DQOIItem = this.svc_dqoi.getDQOIItem(this.dqoiIndex);
            item.quoteId = this.data.quoteId;
            if (!this.settingFromDQOIState) {
                item.customerId = this.data.customerId;
                item.locationId = this.data.locationId;
                if (!this.isConstruction) {
                    item.dispatchId = this.data.dispatchId;
                }
                else {
                    item.jobId = this.data.dispatchId;
                }
                item.invoiceId = this.data.invoiceId;
            }
            this.svc_dqoi.setDQOIItem(item);
            //this.svc_dqoi.nextDQOIState(data);
        }
    }

    subs_importBid: Subscription;
    subs_quoteTemplateSelected: Subscription;
    subs_setupEtc: Subscription;
    subs_getTaxCode: Subscription;
    subs_createJobFromQuote: Subscription;
    subs_getConstructionBidNCStatus: Subscription;
    override ngOnDestroy() {
        super.ngOnDestroy();
        CommonFunctions.unsubscribe(this.subs_importBid);
        CommonFunctions.unsubscribe(this.subs_quoteTemplateSelected);
        CommonFunctions.unsubscribe(this.subs_setupEtc);
        CommonFunctions.unsubscribe(this.subs_getTaxCode);
        CommonFunctions.unsubscribe(this.subs_createJobFromQuote);
        CommonFunctions.unsubscribe(this.subs_getConstructionBidNCStatus);
    }

    importBid2() {
        CommonFunctions.unsubscribe(this.subs_importBid);
        let id: string = '00000000-0000-0000-0000-000000000000';
        //this.subs_importBid = this.svc_data.importBid(id).subscribe(data => {
        //    if (data !== null) {
        //        this.addtlData.lineItems = data;
        //    }
        //});
    }
    delete() {
        if (this.data.isAdded) {
            this.clear();
        }
        else {
            this.mainLoadingOn(true, this.compLoader);
            CommonFunctions.unsubscribe(this.subs_delete);
            this.subs_delete = this.svc_data.deleteQuote(this.id).subscribe((info: BaseMessageInfo) => {
                this.mainLoadingOff(true, this.compLoader);
                if (!info.saveError) {
                    this.deleteSuccess();
                    this.clear();
                }
                else {
                    this.deleteError(info.message);
                }
            });
        }
    }
    get hasStatus(): boolean {
        return this.hasEditForm && CommonFunctions.hasGuidValue(this.editForm.value.quoteStatusId);
    }
    get statusId(): any {
        return this.hasStatus ? this.editForm.value.quoteStatusId : null;
    }
    get originalStatusId(): any {
        return this.hasData ? this.data.quoteStatusId : null;
    }
    get hasOriginalStatusId(): any {
        return CommonFunctions.hasGuidValue(this.originalStatusId);
    }

    get canDelete(): boolean {
        return (this.hasId || (this.hasData && this.data.isAdded)) && this.rights.DeleteQuote && this.serviceMode !== "1";
    }
    get canEdit(): boolean {
        let can: boolean = false;

        //if ((this.hasId || (this.hasData && this.data.isAdded))) {
        if (this.rights.MaintainQuotes && this.serviceMode !== "1") {
            can = true;
        }
        //}

        return can;
    }
    get canImport(): boolean {
        return this.hasCustomerLocation && this.serviceMode !== "1";
    }
    get canSaveTemplate(): boolean {
        return this.serviceMode !== "1" && this.hasId;
    }
    get canCreateJobFromQuote(): boolean {
        return this.isConstruction && !this.hasDispatch;
    }
    override customParentMessage(e: Message) {
        if (e.messageType === MessageType.taxCodeLoaderOff) {
            this.taxCodeLoading = false;
        }
    }

    importBid(files: Array<FileInfo>) {
        //        CommonFunctions.unsubscribe(this.subs_importBid);
        let attachment: AttachmentBus = new AttachmentBus();
        if (files.length > 0 && CommonFunctions.hasValue(files[0].rawFile)) {
            //const reader = new FileReader();
            //reader.onloadend = () => {
            //    let arr: any[] = (<string>reader.result).split(',');
            //    let bytes: any = arr[1];
            //    attachment.attachment = bytes;
            //    doc.document = bytes;
            //}
            //reader.readAsDataURL(files[0].rawFile);;
            //attachment.attachment = bytes;
            attachment.attachmentName = files[0].name;
            attachment.attachmentType = files[0].extension;
            if (attachment.attachmentType.indexOf('.xlsx') < 0)
            //&& attachment.attachmentType.indexOf('.xls') < 0)
            {
                this.globals.notifyError("The Bid File is not the correct extension.", true);
            }
            else {
                var taxCodeId = this.taxCodeId;
                this.mainLoadingOn(true, this.compLoader);
                CommonFunctions.unsubscribe(this.subs_importBid);
                this.subs_importBid = this.svc_data.importBid(files, attachment, this.globals.userId, this.globals.companyId, taxCodeId).subscribe((info: BaseMessageInfo) => {
                    this.mainLoadingOff(true, this.compLoader);
                    if (!info.saveError) {
                        this.addtlData.setLineItems(info.primaryReturn, true);

                        //needed for Service and Construction Components
                        this.addtlData.lineItems.forEach((lineItem: v_QuoteInvoiceBus) => {
                            lineItem.quoteId = this.addtlData?.detail?.quoteId;
                        });

                        this.data.quoteDesc = info.dcValues.description;
                        this.data.scopeText = info.dcValues.scope;

                        this.editForm.patchValue({
                            quoteDesc: this.data.quoteDesc,
                            scopeText: this.data.scopeText,
                        });
                        //this.cd.detectChanges();
                        this.scopeText = info.dcValues.scope;
                        if (info.message) { this.globals.notifyError(info.message); }
                        else { this.globals.notifySuccess("Bid Successfully Imported"); }
                        //                     this.lineItemsComp.calcTotals();
                        this.setTaxCode(this.taxCodeId);
                        setTimeout(() => {
                            //Get sum object from line items grid and set parent object
                            let liTotalsObj: QuoteBus = this.lineItemsComp.getCurrentTotals();
                            this.data.cost = liTotalsObj.cost;
                            this.data.costLabor = liTotalsObj.costLabor;
                            this.data.costMaterial = liTotalsObj.costMaterial;
                            this.data.costOther = liTotalsObj.costOther;
                            this.data.saleLabor = liTotalsObj.saleLabor;
                            this.data.saleMaterial = liTotalsObj.saleMaterial;
                            this.data.saleOther = liTotalsObj.saleOther;
                            this.data.taxAmount = liTotalsObj.taxAmount;
                            this.data.total = liTotalsObj.total;
                            this.data.amount = liTotalsObj.amount;
                            this.lineItemsComp.calcTotals();
                            this.setDirty();
                            //this.cd.detectChanges();
                        }, 2000);

                    }
                    else {
                        this.globals.notifyError("There was and error Importing the bid: " + info.message);
                        this.mainLoadingOff(true, this.compLoader);
                    }
                },
                    (error) => {
                        this.globals.notifyError("There was and error Importing the bid: " + error.message,);
                        this.mainLoadingOff(true, this.compLoader);
                    });

            }
        }
    }

    setForSave(): QuoteBus {
        let busObj: QuoteBus = new QuoteBus(this.data);
        busObj.setFromForm(this.editForm.value);
        busObj.billingGeographyInfo = this.billToGeoInfoComp.getData();
        busObj.billingGeographyId = busObj.billingGeographyInfo.geographyId;
        busObj.shippingGeographyInfo = this.locGeoInfoComp.getData();
        let now: Date = DateFunctions.getDateNow();
        busObj.setCommon(this.globals.userId, now, this.globals.companyId);
        busObj.setBeforeSave();
        return busObj;
    }
    saveIndividual() {
        this.mainLoadingOn(true, this.compLoader);
        let busObj: QuoteBus = this.setForSave();
        CommonFunctions.unsubscribe(this.subs_save);
        this.subs_save = this.svc_data.saveQuote(this.globals.userId, busObj).subscribe((data: QuoteInfo) => {
            this.mainLoadingOff(true, this.compLoader);
            if (!data.saveError) {
                this.getDataFromId(data.quote.quoteId);
                this.saveSuccess();
            }
            else {
                this.saveError(data.message);
            }
            this.readOnly = true;
        });

    }
    refreshMessage(event: any) {
        this.pageData.getDispatchAttachments(this.id);

    }
    getGeneralContractors(): string[] {
        let gc: string[] = [];
        if (CommonFunctions.hasArrayValue(this.addtlData.quoteGC)) {
            for (let i = 0; i < this.addtlData.quoteGC.length; i++) {
                gc.push(this.addtlData.quoteGC[i].value);
            }
        }
        return gc;
    }

    getAddtlData() {

        if (this.hasId) {
            this.addtlDataLoader = true;
            CommonFunctions.unsubscribe(this.subs_dataAddInfo);
            this.pageData.getDispatchAttachments(this.id);
            this.pageData.getAttachments(this.data.quoteId);
            this.subs_dataAddInfo = this.svc_data.getAdditionalData(this.id).subscribe(data => {
                this.addtlData = new AdditionalQuoteData(data);
                this.gridDataPopulateEvent(data?.lineItems && data.lineItems.length > 0)
                this.lineItemsComp.avalaraTaxAmount = this.addtlData.detail.taxAmount;
                this.setAddtlData();
                this.setFormAddtl();
                this.addtlDataLoader = false;
                this.setFormFlags();
            });
        }
        else {
            //ensures new quotes always start from scratch with a false hasLineItems value
            this.gridDataPopulateEvent(false);
        }
    }
    setAddtlData() {
        if (CommonFunctions.hasGuidValue(this.data.taxCodeId)) {
            this.setTaxCode(this.data.taxCodeId);
        }
    }
    getData() {
        super.getData();
    }
    getDataFromId(id: any) {
        this.mainLoadingOn(true, this.compLoader);
        CommonFunctions.unsubscribe(this.subs_data);
        this.subs_data = this.svc_data.get(id).subscribe((data: QuoteBus) => {

            if (data !== null) {
                this.id = data.quoteId;
                this.setData(data);
                this.getData();
            }
            this.mainLoadingOff(true, this.compLoader);
            this.setFormFlags();
        });
    }
    getDataFromNumber(number: string) {
        this.mainLoadingOn(true, this.compLoader);
        CommonFunctions.unsubscribe(this.subs_data);
        this.subs_data = this.svc_data.getFromNumber(number).subscribe((data: QuoteBus) => {
            if (data !== null) {
                this.id = data.quoteId;
                this.setData(data);
                this.getData();
            }
            this.mainLoadingOff(true, this.compLoader);
            this.setFormFlags();
        });
    }
    createNew(busObj: QuoteBus) {
        let newBusObj = new QuoteBus(busObj);
        this.setBillToGeoInfo(new GeographyInfoBus());
        this.setLocationGeoInfo(new GeographyInfoBus());
        return newBusObj;
    }
    afterDataSet() {
        this.customerChanged(this.data.customerId, this.holdCusLocDefaults);

        if (CommonFunctions.hasValue(this.referenceData) && CommonFunctions.hasArrayValue(this.referenceData.locations) && CommonFunctions.hasValue(this.data.customerId)) {
            if (this.data && this.data.isPotentialCustomer) {
                this.customerLocations = this.referenceData.potentialLocations.filter(e => e.category === this.data.customerId);
            }
        }

        this.locationChanged(this.data.locationId);
        this.setBillToGeoInfo(this.data.billingGeographyInfo);
        this.setLocationGeoInfo(this.data.shippingGeographyInfo);
        if (this.hasId && !this.isAdded) {
            this.refreshDQOIItem(this.id);
        }
        super.afterDataSet();
    }
    setBillToAddress(data: Address, locationName: string = null) {
        this.billToAddress = new Address(data);
        this.billToAddress.locationName = locationName;
    }
    setLocationAddress(data: Address, locationName: string = null) {
        this.locationAddress = new Address(data);
        this.locationAddress.locationName = locationName;
    }
    billToChanged(e: GItem) {
        CommonFunctions.unsubscribe(this.subs_geographyAddressBillTo);
        this.subs_geographyAddressBillTo = this.svc_customer.getGeographyAddress(e.value).subscribe((data: Address) => {
            this.setBillToAddress(data, this.billToAddress.locationName);
        });
    }
    panelExpand(e: any) {
        if (e === 'DOC' && !this.pageData.hasAttachments) {
            this.pageData.getAttachments(this.data.quoteId);
        }
    }
    onTabSelect(e: SelectEvent) {

        if (this.hasId) {
            if (e.title === 'Equipment' && !this.pageData.hasQuoteEquipment) {
                this.pageData.getQuoteEquipment(this.data.quoteId);
            }
            else if (e.title === 'Status History' && !this.pageData.statusHistory) {
                this.pageData.getStatusHistory(this.data.quoteId);
            }
            else if (e.title === 'Attachments' && !this.pageData.attachments) {
                this.pageData.getAttachments(this.data.quoteId);
            }
        }
        if (this.hasData && CommonFunctions.hasValue(this.data.dispatchId)) {
            if (e.title === 'Dispatch Labor' && CommonFunctions.hasValue(this.data.dispatchId) && !this.pageData.dispatchLabor) {
                this.pageData.getDispatchLabor(this.data.dispatchId);
            }
            else if (e.title === 'Dispatch Attachments' && CommonFunctions.hasValue(this.data.dispatchId) && !this.pageData.dispatchAttachments) {
                this.pageData.getDispatchAttachments(this.data.dispatchId);
            }
        }
        //else Status History
    }
    setCustomerLocation(customerId: any, locationId: any) {
        this.data.customerId = customerId;
        this.data.locationId = locationId;
        super.setCustomerLocation(customerId, locationId);
    }
    dispatchSearch: boolean = false;
    doDispatchSearch(e: any) {
        if (CommonFunctions.hasStringValue(e) && e === "CLEAR") {

            //   this.editForm.value.masterJobId = null;
            this.editForm.patchValue({
                dispatchNumber: null,
                dispatchId: null
            });
            this.setDirty();
            //            this.cpQuoteSelected({ DispatchNumber: "", DispatchId: null });
        }
        else {
            this.dispatchSearch = true;
            this.CpSearchDispatchs.setSearchText(e);
        }
    }

    dispatchSelected(value: any) {
        this.isRelJobTypeCO = false;
        this.dispatchSearch = false;
        if (value != null) {
            if (this.isConstruction) {
                this.editForm.patchValue({
                    customerId: value.CustomerId,
                    locationId: value.LocationId,
                    dispatchNumber: value.DispatchNumber,
                    dispatchId: value.DispatchId,
                    accountClassId: value.AccountClassId,
                    wonumber: value.Wonumber
                });

                if (this.compFeatureFlagSet.featureFlagSet['quotes-new-status-for-pending-atp']) {
                    if (value.RelatedJobTypeId == CommonValues.RelatedJobType_ChangeOrder && !this.editForm?.value?.isPassThrough) {
                        this.isRelJobTypeCO = true;
                        this.editForm.patchValue({
                            quoteStatusId: CommonValues.Quote_PendingATP
                        });
                    } else {
                        this.editForm.patchValue({
                            quoteStatusId: CommonValues.Quote_Pending
                        });
                    }
                }

                this.setCustomerLocation(value.CustomerId, value.LocationId);
                this.checkBidNCStatus();
                this.setDirty();
            }
            else {
                console.log("disp-sel: ", value, value.QuoteId, this.id, this.data);
                if (CommonFunctions.hasGuidValue(value.QuoteId) && CommonFunctions.hasGuidValue(this.id) && value.QuoteId != this.id) {
                    let msg: string = "There is already a Dispatch Linked to this Quote would you like to Unlink it?";
                    let title: string = "Dispatch Already Linked to This Quote";
                    this.cnfShow(msg, CRUDActions.None, value, title, "DISPATCHQUOTE_LINKED", false);
                }
                else {
                    //this.editForm.controls["dispatchNumber"].setValue(value.DispatchNumber);
                    this.editForm.patchValue({
                        dispatchNumber: value.DispatchNumber,
                        dispatchId: value.DispatchId,
                        wonumber: value.Wonumber
                    });
                    this.setDirty();
                }
            }
        }
    }

    dispatchValidationError(event: any) {
        this.dispatchSearch = true;
    }
    dispatchValidate(value: any) {
        console.log("quote->dispval: ", value);
        var skipCheck = false;
        if (!value) {

            this.editForm.patchValue({
                dispatchNumber: value,
                dispatchId: null
            });
            skipCheck = true;
        }
        else {
            var dispatchId = this.editForm.controls["dispatchId"].value;
            var dispatchNumber = this.editForm.controls["dispatchNumber"].value;
            if (dispatchId) {
                if (dispatchNumber === value) { skipCheck = true; }
            }
        }

        if (!skipCheck) {
            this.dispatchSearch = false;
            this.CpSearchDispatchs.validate(value);
        }

    }

    confirmCustom(data: ConfirmOutput) {
        if (data.code === "DISPATCHQUOTE_LINKED") {
            if (data.dialogResult === CPDialogResult.ok) {
                //Unlink - when save unlink
                this.editForm.patchValue({
                    dispatchNumber: data.data.DispatchNumber,
                    dispatchId: data.data.DispatchId
                });
                this.setDirty();
            }
            else {
                //any restore
                this.editForm.patchValue({
                    dispatchNumber: this.editForm.value.dispatchNumber,
                    dispatchId: this.editForm.value.dispatchId
                });
                this.setDirty();
            }
        } else if (data.code === `EQUIP_W_INSTALL`) {
            this.setControlValue('isEquipmentWithInstall', data.dialogResult === 1, true);
        } else if (data.code === `MANUAL_EQUIP_W_INSTALL`) {
            const value = data.dialogResult === 1 ? false : true;
            this.setControlValue('isEquipmentWithInstall', value, true);
        }
    }

    saveTemplatePopup() {
        this.quoteTemplateSaveComponent.show();
        //        this.templateSaveActive = true;
    }
    saveTemplate(data: QuoteTemplate) {
        let note: string = "Quote Template " + data.QuoteTemplateName + " Successfully Saved";
        this.globals.notifySuccess(note);
    }
    errorTemplate(data: QuoteTemplate) {
        let note: string = "Error saving Quote Template ";
        this.globals.notifyError(note, true);
    }

    PassThroughCheckBoxChanged(e: any) {
        if (this.compFeatureFlagSet.featureFlagSet['quotes-new-status-for-pending-atp']) {
            if (this.isRelJobTypeCO) {
                if (this.editForm?.value?.isPassThrough) {
                    this.editForm.patchValue({
                        quoteStatusId: CommonValues.Quote_Pending
                    });
                } else {
                    this.editForm.patchValue({
                        quoteStatusId: CommonValues.Quote_PendingATP
                    });
                }
            }
        }
    }

    templateSaveActive: boolean = false;
    templateName: string = "";
    quoteTemplateSearch: boolean = false;
    doQuoteTemplateSearch(e: any) {

        if (CommonFunctions.hasStringValue(e) && e === "CLEAR") {
            //            this.cpQuoteSelected({ DispatchNumber: "", DispatchId: null });
        }
        else {
            this.quoteTemplateSearch = true;
            this.CpSearchQuoteTemplates.setSearchText(e);
        }
    }
    quoteTemplateSelected(value: any) {
        this.quoteTemplateSearch = false;
        if (value != null) {
            let busObj: QuoteTemplate = new QuoteTemplate(value);
            //this.editForm.controls["dispatchNumber"].setValue(value.DispatchNumber);
            this.templateName = value.QuoteTemplateName;
            CommonFunctions.unsubscribe(this.subs_quoteTemplateSelected);
            this.subs_quoteTemplateSelected = this.svc_data.getQuoteFromTemplate(busObj.QuoteTemplateId).subscribe((info: QuoteMessageInfo) => {
                let quote: QuoteBus = new QuoteBus(info.primaryReturn as QuoteBus) as QuoteBus;
                this.getDataFromId(quote.quoteId);
                this.addtlData = new AdditionalQuoteData(info.dcValues.AddtlData);
                this.setAddtlData();
                this.setFormAddtl();
                this.saveMode = SaveMode.all;
                this.pageData.setAttachments(info.dcValues.Attachments);
                //this.setd
            });
        }
    }

    quoteTemplateValidationError(event: any) {

        this.quoteTemplateSearch = true;
    }
    quoteTemplateValidate(value: any) {

        var skipCheck = false;
        if (!value) {

            this.editForm.patchValue({
                dispatchNumber: value,
                dispatchId: null
            });
            skipCheck = true;
        }
        else {
            var dispatchId = this.editForm.controls["dispatchId"].value;
            var dispatchNumber = this.editForm.controls["dispatchNumber"].value;
            if (dispatchId) {
                if (dispatchNumber === value) { skipCheck = true; }
            }
        }
        skipCheck = true;
        if (!skipCheck) {
            this.dispatchSearch = false;
            this.CpSearchQuoteTemplates.validate(value);
        }
    }

    getCustomerLocationPriceRanges(id: any) {
        this.svc_customer.getLocationPricing(id).subscribe(locData => {
            if (locData.length > 0) {
                this.custLocPricingRanges = locData;
            } else {
                this.svc_customer.getCustomerPricing(this.customerId).subscribe(custData => {
                    this.custLocPricingRanges = custData;
                });
            }
        });
    }

    getLocationDefaults(id: any) {
        CommonFunctions.unsubscribe(this.subs_locationDefaults);
        let subServ: any;

        if (this.compFeatureFlagSet.featureFlagSet['get-location-defaults-potential-customers']) {
            if (this.data.quoteId) {
                subServ = this.svc_data.getQuoteNormalOrPotentialLocationGeo(this.data.quoteId);
            } else {
                subServ = this.svc_data.getQuoteDefaultsFromLocation(id);
            }
        }
        else {
            subServ = this.svc_data.getQuoteDefaultsFromLocation(id);
        }

        this.subs_locationDefaults = subServ.subscribe((data: v_LocationDetailBus) => {
            this.locationDetail = new v_LocationDetailBus(data);
            let locGeoInfo: GeographyInfoBus = new GeographyInfoBus();
            locGeoInfo.set(data.geographyId, data.locationName, data.addressLine1, data.addressLine2, data.city, data.stateProvince, data.countryCd, data.county, data.postalCode);
            let billToGeoInfo: GeographyInfoBus = new GeographyInfoBus();
            billToGeoInfo.set(data.billingGeographyId, data.billingAddressName, data.billingAddressLine1, data.billingAddressLine2, data.billingCity, data.billingStateProvince, data.countryCd, data.billingCounty, data.billingPostalCode);
            this.setLocationGeoInfo(locGeoInfo);
            if (!this.validBillToGeoInfoGeographyId()) {
                this.setBillToGeoInfo(billToGeoInfo);
            }
            this.data.setTaxCode(data.taxCode);
            if (!this.hasId && !this.holdCusLocDefaults) {
                this.setFormLocation(data);
            }
            this.holdCusLocDefaults = false;
        });

    }
    print(checkSave: boolean = true) {
        if (checkSave && this.isDirty) {
            this.afterSaveAction = CommonActions.Print;
            this.saveAll();
        }
        else {
            this.compLoader.cpLoaderOn();
            CommonFunctions.unsubscribe(this.subs_print);
            if(this.compFeatureFlagSet.featureFlagSet["ui-enable-new-quote-printing"]) {
                this.subs_print = this.svc_data.printUsingIronPdf(this.id).subscribe((data: PdfResponse) => {
                    if(CommonFunctions.hasValue(data) && !data.hasErrors) {
                        this.printService.printIronPdf(data, "Quote-" + this.data.quoteNumber + ".pdf");
                    }
                    else {
                        this.notifyError("- A pdf of Quote " + this.data.quoteNumber + " could not be generated.");
                    }
                    this.compLoader.cpLoaderOff();
                },
                (error) => {
                    this.handleError(error);
                });
            }
            else {
                this.subs_print = this.svc_data.print(this.id).subscribe((data: CDocument) => {
                    this.printService.printPdf(data);
                    this.compLoader.cpLoaderOff();
                });
            }
        }
    }

    refresh() {
        if (this.data.quoteId) {
            let origStatusId: any = this.originalStatusId;
            this.resetMasterList = true;
            this.getDataFromId(this.data.quoteId);
            this.pageData.getAttachments(this.data.quoteId);
            if (this.attachmentsComp) { this.attachmentsComp.clearDeleted(); }
            if (this.lineItemsComp) { this.lineItemsComp.clearDeleted(); }
            if (this.notesComp) { this.notesComp.clearDeleted(); }
            if (this.equipComp) { this.equipComp.clearDeleted(); }
        }
    }

    setup(data: any, code: string = null) {
        if (code === "CRFROMDISPATCH" || code === "CRFROMJOB") {
            this.mainLoadingOn(true, this.compLoader);
            let id: any = code === "CRFROMDISPATCH" ? data.dispatchId : data.id;
            CommonFunctions.unsubscribe(this.subs_setupEtc);
            this.subs_setupEtc = this.svc_data.createNewFromDispatch(id).subscribe((info: QuoteMessageInfo) => {

                if (info.saveError) {
                    this.notifyError("Creating Quote");
                    this.mainLoadingOff(true, this.compLoader);
                }
                else {
                    this.addtlData = new AdditionalQuoteData();

                    let arr2a = [];
                    if (CommonFunctions.hasArrayValue(info.dcValues.lineItems)) {
                        for (let i = 0; i < info.dcValues.lineItems.length; i++) {
                            let newObj: v_QuoteInvoiceBus = new v_QuoteInvoiceBus(info.dcValues.lineItems[i]);
                            newObj.quoteInvoiceId = CommonFunctions.getGuid();
                            arr2a.push(newObj);
                        }
                    }

                    this.addtlData.lineItems = arr2a;
                    let arr = [];
                    if (CommonFunctions.hasArrayValue(info.dcValues.notes)) {
                        for (let i = 0; i < info.dcValues.notes.length; i++) {
                            let newObj: v_QuoteNoteBus = new v_QuoteNoteBus(info.dcValues.notes[i]);
                            if (!newObj.updateUserId) {
                                newObj.updateUserId = this.globals.userId;
                            }
                            if (!newObj.insertUserId) {
                                newObj.insertUserId = this.globals.userId;
                            }
                            if (!newObj.quoteId) {
                                newObj.quoteId = this.globals.userId;
                            }
                            arr.push(newObj);
                        }
                    }
                    this.addtlData.notes = arr;
                    // this.addtlData.notes = info.dcValues.notes;
                    this.addtlData.detail = new v_QuoteDetailBus(info.dcValues.Detail);
                    this.holdCusLocDefaults = true;
                    this.setData(info.quote);
                    this.dqoiIndex = data.index;
                    console.log("q-setup: ", this.addtlData, info);
                    data.quoteNumber = info.quote.quoteNumber;
                    this.setFormAddtl();
                    this.svc_dqoi.setDQOIItem(data);
                    this.edit();
                    this.mainLoadingOff(true, this.compLoader);
                    this.setDirty();
                    this.setFormFlags();
                }
            });
        }
        else if (code === "CRFROMINVOICE") {
            this.mainLoadingOn(true, this.compLoader);
            let id: any = data.invoiceId;;
            CommonFunctions.unsubscribe(this.subs_setupEtc);
            this.subs_setupEtc = this.svc_data.createNewFromInvoice(id).subscribe((info: QuoteMessageInfo) => {
                if (info.saveError) {
                    this.notifyError("Creating Quote");
                    this.mainLoadingOff(true, this.compLoader);
                }
                else {
                    this.addtlData = new AdditionalQuoteData();

                    let arr2a = [];
                    if (CommonFunctions.hasArrayValue(info.dcValues.addtlData.lineItems)) {
                        for (let i = 0; i < info.dcValues.addtlData.lineItems.length; i++) {
                            let newObj: v_QuoteInvoiceBus = new v_QuoteInvoiceBus(info.dcValues.addtlData.lineItems[i]);
                            newObj.quoteInvoiceId = CommonFunctions.getGuid();
                            newObj.isAdded = true;
                            arr2a.push(newObj);
                        }
                    }

                    this.addtlData.lineItems = arr2a;
                    let arr = [];
                    if (CommonFunctions.hasArrayValue(info.dcValues.addtlData.notes)) {
                        for (let i = 0; i < info.dcValues.addtlData.notes.length; i++) {
                            let newObj: v_QuoteNoteBus = new v_QuoteNoteBus(info.dcValues.addtlData.notes[i]);
                            newObj.isAdded = true;
                            arr.push(newObj);
                        }
                    }
                    this.addtlData.notes = arr;
                    this.addtlData.detail = new v_QuoteDetailBus(info.dcValues.addtlData.Detail);
                    this.holdCusLocDefaults = true;
                    this.setData(info.quote);
                    this.dqoiIndex = data.index;
                    console.log("q-setup: ", this.addtlData, info);
                    this.setFormAddtl();
                    this.svc_dqoi.setDQOIItem(data);
                    this.edit();
                    this.mainLoadingOff(true, this.compLoader);
                    this.setDirty();
                    this.setFormFlags();
                    console.log("q-setup-end: ", this.addtlData, info);
                }
            });
        }
        else if (code === "GOTO") {
            this.clear();
            this.checkChange(this.dqoiIndex, SearchTarget.quote, false);
            this.getDataFromId(data.id);
        }
    }
    testHotKeyState: boolean = false;

    setNewDefaults() {
        super.setNewDefaults();
        if (this.isConstruction) {
            this.data.salespersonId = null;
            this.isNewQuote = true;
        }
        this.editForm.patchValue({
            quoteDate: DateFunctions.getDateNow(),
            quoteStatusId: CommonValues.Quote_Pending,
            printWithTerms: true,
        });
        //        this.cd.detectChanges();
    }
    get salespersonId(): any {
        return this.hasEditForm ? this.editForm.value.salespersonId : null;
    }
    get taxCodeId(): any {
        return this.hasEditForm ? this.editForm.value.taxCodeId : null;
    }
    get hasSalespersonId(): boolean {
        return CommonFunctions.hasGuidValue(this.salespersonId);
    }
    customFormValidation() {
        var valid = super.customFormValidation() && (this.isConstruction ? this.hasSalespersonId : true);
        if(this.compFeatureFlagSet.featureFlagSet["ui-enable-lineitems-required-for-quote-save"]) {
            valid = valid && this.hasLineItems;
        }

        return valid;
    }

    testText: string = "";
    saveAll() {
        let busSaveObj: QuoteBus = this.setForSave();
        let busObj: QuoteSaveParam = new QuoteSaveParam(busSaveObj);

        busObj.lineItems = _.cloneDeep(this.lineItemsComp.getChanged());
        busObj.addDeletedItems(this.lineItemsComp.getDeletedItems());

        //Get sum object from line items grid and set parent object
        let liTotalsObj: QuoteBus = this.lineItemsComp.getCurrentTotals();
        busObj.cost = liTotalsObj.cost;
        busObj.costLabor = liTotalsObj.costLabor;
        busObj.costMaterial = liTotalsObj.costMaterial;
        busObj.costOther = liTotalsObj.costOther;
        busObj.saleLabor = liTotalsObj.saleLabor;
        busObj.saleMaterial = liTotalsObj.saleMaterial;
        busObj.saleOther = liTotalsObj.saleOther;
        busObj.taxAmount = liTotalsObj.taxAmount;
        busObj.total = liTotalsObj.total;
        busObj.amount = liTotalsObj.amount;

        if (CommonFunctions.hasValue(this.notesComp)) {
            busObj.notes = _.cloneDeep(this.notesComp.getChanged());
            busObj.addDeletedItems(this.notesComp.getDeletedItems());
        }
        if (CommonFunctions.hasValue(this.attachmentsComp)) {
            busObj.attachments = _.cloneDeep(this.attachmentsComp.getChanged());
            busObj.addDeletedItems(this.attachmentsComp.getDeletedItems());
        }
        if (CommonFunctions.hasValue(this.equipComp)) {
            busObj.equipment = _.cloneDeep(this.equipComp.getChanged());
            busObj.addDeletedItems(this.equipComp.getDeletedItems());
        }
        this.mainLoadingOn(true, this.compLoader);
        CommonFunctions.unsubscribe(this.subs_save);

        this.subs_save = this.svc_data.saveAll(busObj).pipe(retry(0))
            .subscribe((info: QuoteMessageInfo) => {
                this.mainLoadingOff(true, this.compLoader);
                if (!info.saveError) {
                    let origStatusId: any = this.originalStatusId;
                    this.resetMasterList = true;
                    this.getDataFromId(info.quote.quoteId);
                    this.pageData.getAttachments(this.data.quoteId);
                    this.saveSuccess();
                    if (this.attachmentsComp) { this.attachmentsComp.clearDeleted(); }
                    if (this.lineItemsComp) { this.lineItemsComp.clearDeleted(); }
                    if (this.notesComp) { this.notesComp.clearDeleted(); }
                    if (this.equipComp) { this.equipComp.clearDeleted(); }
                    if (!this.isConstruction && CommonValues.Quote_CalcInProcess(origStatusId) && !this.lineItemsComp.hasProperFreight(this.locState)) {
                        this.showItemsToCheckPrompt();
                    }
                }
                else {
                    this.saveError(info.message);
                }
            },
                (error) => {
                    this.handleSaveError(error);
                });
    }

    handleSaveError(error) {
        this.mainLoadingOff(true, this.compLoader);
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Error: ${error.error.message}`;
        } else {
            // server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        this.saveError(errorMessage);
        return throwError(errorMessage);
    }

    handleError(error) {
        this.mainLoadingOff(true, this.compLoader);
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Error: ${error.error.message}`;
        } else {
            // server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        this.notifyError(errorMessage);
        return throwError(errorMessage);
    }

    protected setNoData(item: DQOIItem) {
        if (CommonFunctions.hasValue(item)) {
            this._masterId = item.dispatchId;
            this.getListFromMaster();
        }
    }
    getListFromMaster() {
        this.masterListLoader = true;
        CommonFunctions.unsubscribe(this.subs_masterList);
        this.subs_masterList = this.svc_data.getListFromMaster(this.masterId).subscribe((info: BaseMessageInfo) => {
            this.masterList = info.primaryReturn;
            this.cloneMasterList();
            this.masterListLoader = false;
        });
    }
    get hasDispatch(): boolean {
        return this.hasData && CommonFunctions.hasValue(this.data.dispatchId);
    }
    createJobFromQuote() {
        this.compLoader.cpLoaderOn(true);
        CommonFunctions.unsubscribe(this.subs_createJobFromQuote);
        this.subs_createJobFromQuote = this.svc_cnst.createNewJobFromQuote(this.id).subscribe((info: CnstMessageInfo) => {
            //this.svc_dqoi.getDQOIItem(this.dqoiIndex);
            this.compLoader.cpLoaderOff();
            info.job.masterJobId = this.masterId;
            this.goTo(info, SearchTarget.job, "CRFROMBID");
        });

    }
    cpQuoteSearch: boolean = false;
    doQuoteSearch(e: any) {
        if (CommonFunctions.hasStringValue(e) && e === "CLEAR") {

            //   this.editForm.value.masterJobId = null;
            this.editForm.patchValue({
                dispatchNumber: null,
                dispatchId: null
            });
        }
        else {
            this.cpQuoteSearch = true;
        }
    }
    cpQuoteSelected(value: any) {
        this.cpQuoteSearch = false;
        if (value != null) {
            this.lineItemsComp.manuallyChangeTaxCode(false);
            this.dataItemSelected({ value: value.QuoteId });
        }
    }
    dataItemSelected(data: any) {
        this.lineItemsComp.manuallyChangeTaxCode(false);
        super.dataItemSelected(data);
    }

    taxCodeCBOChanged(e: GItem) {
        this.lineItemsComp.manuallyChangeTaxCode(true);
        let id: any = e ? e.value : null;
        this.setTaxCode(id);
        if (id == CommonValues.AvalaraExempt_TaxCode || id == CommonValues.AvalaraSTExemptUTMaterials_TaxCode) {
            this.globals.notifyWarning("To use this code, please email the current tax exemption certificate to statetax@climatepros.com.", true);
        }
    }

    taxCodeLoading: boolean = false;
    setTaxCode(id: any, taxCodeLoading: boolean = false) {
        this.isAvalaraTaxCodeInfo = false;
        if (id) {
            this.taxCodeLoading = taxCodeLoading;
            CommonFunctions.unsubscribe(this.subs_getTaxCode);
            this.subs_getTaxCode = this.svc_data.getTaxCode(id).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    if (this.hasLocationDetail) {
                        this.data.setTaxCode(info.primaryReturn);
                        this.setFormTaxCode(this.data.taxCode);
                        if (info.primaryReturn.taxCodeId === CommonValues.Avalara_TaxCode) {
                            this.getAvalaraTaxRate(this.id);
                            this.isAvalaraTaxCodeInfo = true;
                        }
                    }
                }
                else {
                    this.data.setTaxCode(null);
                    this.setFormTaxCode(this.data.taxCode);
                }
            });
        }
        else {
            this.data.setTaxCode(null);
        }
    }

    taxCodeShow() {
        this.taxCodeComponent.setup(this.data.taxCode);
        this.taxCodeActive = true;
    }
    taxCodeActive: boolean = false;
    taxCodeClosed(e: any) {
        this.taxCodeActive = false;
    }

    invoicePickerActive: boolean = false;
    invoicePickerClosed(e: any) {
        this.invoicePickerActive = false;
    }
    dropid: any;
    showDispatch(e) {

        this.invoicePicker.setId(this.data.dispatchId);
        this.invoicePickerActive = true;

    }
    parentdropEvent(e) {
        if (e.detailType == 1 || e.detailType == 2 || e.detailType == 3) {
            if (this.lineItemsComp.canDrop()) {
                this.dropid = e.dropid;
                if (this.lineItemsComp.insertRow()) {
                    this.svc_data.createQuoteLineFrom(SearchTarget.quote, e.dispatchId, e.detailType, e.dropid).subscribe((info: QuoteMessageInfo) => {
                        if (!info.saveError) {

                            var addtlData = new AdditionalQuoteData(info.dcValues);

                            if (addtlData.lineItems && addtlData.lineItems.length > 0) {
                                this.lineItemsComp.updateRow(addtlData.lineItems[0]);

                                this.lineItemsComp.sumGrid();
                                setTimeout(() => {
                                    this.lineItemsComp.sumGrid();
                                    this.editForm.markAsDirty();
                                }, 500);
                            }
                        }

                    });

                }

            }
        }
        if (e.detailType == 4) {
            if (this.notesComp.canDrop()) {
                this.dropid = e.dropid;
                this.notesComp.insertRow();

                this.svc_data.createQuoteLineFrom(SearchTarget.quote, e.dispatchId, e.detailType, e.dropid).subscribe((info: QuoteMessageInfo) => {
                    if (!info.saveError) {

                        var addtlData = new AdditionalQuoteData(info.dcValues);

                        if (addtlData.notes && addtlData.notes.length > 0) {
                            var tempNote = addtlData.notes[0];
                            tempNote.quoteId = this.id;
                            this.notesComp.updateRow(tempNote);

                            this.lineItemsComp.sumGrid();
                            setTimeout(() => {
                                this.lineItemsComp.sumGrid();
                                this.editForm.markAsDirty();
                            }, 500);
                        }
                    }
                });
            }
        }
    }
    cancel() {
        this.lineItemsComp.manuallyChangeTaxCode(false);
        super.cancel();
    }
    showItemsToCheckPrompt() {
        let title: string = "Remember to add freight";
        let messages: string[] = [
            "$0-$200=freight charge of 30 % of total material costs",
            "$200.01 - $500=freight charge of 25 % of total material costs",
            "Over $500 = freight charge of 20 % of total material costs",
            "Hawaii invoices = freight charge of 30 % of total material costs"
        ];
        this.cnfShowSomeGeneralMessages(messages, title, 550);
    }

    navigateToBidsheet() {
        let bidNumber = this.editForm.value.bidSheetNumber;
        let mainBid = this.editForm.value.mainBidNo;
        this.router.navigate(['./construction/bidsheet/', { bidsheetId: bidNumber, mainBidId: mainBid }]);

    }
    bidsheetId: string = '';
    mainBid: string = '';
    getBidData(id) {
        this.svc_data.getBidsheetData(id).subscribe(data => {
            if (data) {
                this.bidsheetId = data.bidSheetNumber;
                this.mainBid = data.mainBidSheetsId;
                this.editForm.patchValue({
                    bidSheetNumber: this.bidsheetId,
                    mainBidNo: this.mainBid
                });
            }
        });
    }

    onClassChanged(item: GItem) {
        if (!CommonFunctions.hasValue(item)) {
            return;
        }

        if (this.isConstruction) {
            this.checkBidNCStatus();
        }

        if (this.isConstruction) {

            if (item.value?.toLowerCase() === CommonValues.Quote_Class_Equipment_Sales) {
                this.showEquipmentWithInstallDialog();
                this.isEquipmentWithInstallReadOnly = false;
            } else {
                this.setControlValue(`isEquipmentWithInstall`, null, true);
                this.isEquipmentWithInstallReadOnly = true;
            }
        }
    }

    private showEquipmentWithInstallDialog(): void {
        let msg: string = "Does this Equipment Sale include installation?";
        let title: string = "Equipment With Install";
        this.cnfDialog.show(msg, null, null, title, `EQUIP_W_INSTALL`, false, true);
    }

    public isEquipWithInstallClickHandler(): void {

        var selectedAccountClassId = this.editForm?.value?.accountClassId;

        const currentAccountClass = this.accountClasses.find(x => x.value === selectedAccountClassId);

        if (this.editForm?.value?.isEquipmentWithInstall === true &&
            currentAccountClass?.value?.toLowerCase() === CommonValues.Quote_Class_Equipment_Sales) {
            this.cnfDialog.show(`Are you sure this Equipment Sales does not include an install?`
                , CRUDActions.None, null, `Please Confirm`, `MANUAL_EQUIP_W_INSTALL`
                , false, true);
        }

    }

    checkBidNCStatus() {
        if (this.isConstruction && this.editForm?.value?.dispatchId && this.editForm?.value?.accountClassId) {
            let jobId = this.editForm?.value?.dispatchId;
            let classId = this.editForm?.value?.accountClassId;
            this.subs_getConstructionBidNCStatus = this.svc_data.getConstructionBidNCStatus(jobId, classId).subscribe(data => {
                this.editForm.patchValue({
                    isNewConstruction: data[0].isChecked
                });
                data[0].isReadyOnly ? this.editForm.get('isNewConstruction').disable() : this.editForm.get('isNewConstruction').enable();
            });
        }
    }

    getAvalaraTaxRate(quoteId: string) {
        this.svc_data.getAvalaraTaxRate(quoteId).subscribe((data: any) => {
            if (data.hasPrimaryReturn && this.data.taxCode) {
                this.data.taxCode.taxRate = data.primaryReturn;
            }
        });
    }

    gridDataPopulateEvent(hasGridData: boolean) {
        this.hasLineItems = hasGridData;
    }
}
